import {Component, EventEmitter, Input, Output} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Component({
  selector: 'si-delete-icon',
  templateUrl: './delete-icon.component.html',
  styleUrls: ['./delete-icon.component.scss']
})
export class DeleteIconComponent {
  @Input() icon = 'icosun-bin';
  @Input() iconClass: string;
  @Input() tooltip: string;
  @Input() tooltipPosition = 'top';
  @Input() path: string;
  @Input() model: any;
  @Input() titleDialog: string;
  @Input() titleDialogStyleClass: string;
  @Input() textDialog: string;
  @Input() putMethod = false;
  @Input() button1Text: string;
  @Input() button1Class = 'si-button_secondary';
  @Input() button2Text: string;
  @Input() button2Class = 'si-button_main';
  @Output() updateChange = new EventEmitter<any>();
  displayDialog = false;

  constructor(private http: HttpClient) {
  }

  onClickIcon(event: Event): void {
    event.stopPropagation();
    if (this.titleDialog) {
      this.displayDialog = true;
    } else {
      this.onClickCloseDialog(true);
    }
  }

  async onClickCloseDialog(action: boolean): Promise<any> {
    if (action) {
      await this.deleteItem();
      this.updateChange.emit();
    }

    this.displayDialog = false;
  }

  async deleteItem(): Promise<any> {
    if (!this.path) {
      return;
    }

    if (this.putMethod) {
      await this.http.put(this.path, this.model ?? {}).toPromise();
    } else {
      await this.http.delete(this.path).toPromise();
    }
  }

  onChangeDisplayDialog(displayDialog: boolean): void {
    this.displayDialog = displayDialog;
  }
}
